import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import MUITable from "../../../../Common/MUITable";
import Loader from "../../../../Common/Loader/loader";
import useGrievanceReportStore from "../../GrievanceDetailedReport/store/grievanceReportStore";
import isGHMC from "../../../../Common/helper/helpar";
import { MSWManagementTertiaryVehiclesFilter } from "./MSWManagementTertiaryVehiclesFilter";


export const MSWManagementTertiaryVehiclesMonthlyReport = () => {
    const {
        loading,
        fetchgrievanceDetailedReport,
        selectComplaintNo,
        selectedStatus,
        selectIEName } = useGrievanceReportStore();
    const isProd = isGHMC()

    useEffect(() => {
        // Initial fetch without filters
        fetchgrievanceDetailedReport();
    }, []);

    // Function to fetch data with filters when clicking search
    const handleSearch = () => {
        fetchgrievanceDetailedReport({
            complaintNo: selectComplaintNo,
            status: selectedStatus,
            ieEngineerId: selectIEName

        });
    };

    const grievanceReportHeaderColumns = [
        { label: "Zone", field: "complaintNo" },
        { label: "Circle", field: "complaintNo" },
        { label: "Alloted Vehicles", field: "complaintNo" },
        { label: "1", field: "complaintNo" },
        { label: "%", field: "complaintNo" },
        { label: "2", field: "complaintNo" },
        { label: "%", field: "complaintNo" },
        { label: "3", field: "complaintNo" },
        { label: "%", field: "complaintNo" },
        { label: "4", field: "complaintNo" },
        { label: "%", field: "complaintNo" },
        { label: "5", field: "complaintNo" },
        { label: "%", field: "complaintNo" },
        { label: "6", field: "complaintNo" },
        { label: "%", field: "complaintNo" },
        { label: "7", field: "complaintNo" },
        { label: "%", field: "complaintNo" },
        { label: "8", field: "complaintNo" },
        { label: "%", field: "complaintNo" },
        { label: "9", field: "complaintNo" },
        { label: "%", field: "complaintNo" },
        { label: "10", field: "complaintNo" },
        { label: "%", field: "complaintNo" },
        { label: "11", field: "complaintNo" },
        { label: "%", field: "complaintNo" },
        { label: "12", field: "complaintNo" },
        { label: "%", field: "complaintNo" },
        { label: "13", field: "complaintNo" },
        { label: "%", field: "complaintNo" },
        { label: "14", field: "complaintNo" },
        { label: "%", field: "complaintNo" },
        { label: "15", field: "complaintNo" },
        { label: "%", field: "complaintNo" },
        { label: "16", field: "complaintNo" },
        { label: "%", field: "complaintNo" },
        { label: "17", field: "complaintNo" },
        { label: "%", field: "complaintNo" },
        { label: "18", field: "complaintNo" },
        { label: "%", field: "complaintNo" },
        { label: "19", field: "complaintNo" },
        { label: "%", field: "complaintNo" },
        { label: "20", field: "complaintNo" },
        { label: "%", field: "complaintNo" },
        { label: "21", field: "complaintNo" },
        { label: "%", field: "complaintNo" },
        { label: "22", field: "complaintNo" },
        { label: "%", field: "complaintNo" },
        { label: "23", field: "complaintNo" },
        { label: "%", field: "complaintNo" },
        { label: "24", field: "complaintNo" },
        { label: "%", field: "complaintNo" },
        { label: "25", field: "complaintNo" },
        { label: "%", field: "complaintNo" },
        { label: "26", field: "complaintNo" },
        { label: "%", field: "complaintNo" },
        { label: "27", field: "complaintNo" },
        { label: "%", field: "complaintNo" },
        { label: "28", field: "complaintNo" },
        { label: "%", field: "complaintNo" },
        { label: "29", field: "complaintNo" },
        { label: "%", field: "complaintNo" },
        { label: "30", field: "complaintNo" },
        { label: "%", field: "complaintNo" },
      

    ];

    return (

        <div>
            <div className="card mt-3">
                <div className="">
                    <div className="top-header">
                        <span>Day Wise Vehicles Deployment</span>
                    </div>
                    <MSWManagementTertiaryVehiclesFilter />
                    {/* {isFetchingZoneWiseTrips && <Loader />} */}

                    {loading ? <Loader /> : (
                        <MUITable
                            needSRNumber
                            columns={grievanceReportHeaderColumns}
                            // rows={grievanceReportData}
                            tableHeight={500}
                        />
                    )}
                </div>
            </div>
        </div>
    );
};
